module.exports = {
  "Sort": require("./Sort").default,
  "Langton's Ant": require('./Langtonsant').default,
  "Snake": require('./Snake').default,
  "Hello World": require('./HelloWorld').default,
}



// WEBPACK FOOTER //
// ./src/sketches/index.js